export class LinkPropertyTransformer {
  static transform(text: string): string {
    return text.startsWith('http') ? text : `https://${text}`;
  }
}
